import { useMemo, useState } from "react";
import {
  EMPTY_FILTERS,
  MedicationListFilters,
  MedicationListItem,
} from "../data-model/medicationListModel";
import {
  matchesFilters,
  matchesSearch,
  sortByDisplayName,
} from "../utils/medicationListHelpers";

interface UseMedicationFiltersResult {
  search: string;
  setSearch: (value: string) => void;
  filters: MedicationListFilters;
  setFilters: (next: MedicationListFilters) => void;
  filteredRows: MedicationListItem[];
}

export const useMedicationFilters = (
  medications: MedicationListItem[],
): UseMedicationFiltersResult => {
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState<MedicationListFilters>(EMPTY_FILTERS);

  const filteredRows = useMemo(() => {
    return medications
      .filter((m) => matchesSearch(m, search) && matchesFilters(m, filters))
      .sort(sortByDisplayName);
  }, [medications, search, filters]);

  return {
    search,
    setSearch,
    filters,
    setFilters,
    filteredRows,
  };
};
